import React, { useRef, useState, useEffect, useContext } from 'react'
import { useForm } from '../../Hooks/useForm';
import { Dialog } from 'primereact/dialog';
import { getEstadosCategoryIPS } from '../../API/Global/Estados/StatusRequest';
import { Toast } from 'primereact/toast';
import { AuthContext } from '../../Context/AuthContext/AuthContext';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { CambiarEstadoIncripcion, CambiarEstadoInscripcion, getInfoCliente } from '../../API/Clientes/ClientesRequest';
import { Button } from 'primereact/button';
import { toastShow } from '../../Services/ToastService';
import { getDateTimeStringSQL24 } from '../../Services/Moment/Luxon';

const DialogEstadoRevisadoClientes = ({ visible, hideDialog, IdCliente, Token }) => {

    const toast = useRef(null);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [estadosRevision, setEstadosRevision] = useState([]);
    const { values, setValues, resetForm, handleInputChange, handleChange } = useForm({
        IdEstadoRevisado: null,
        IdUsuarioFinanzas: null,
        FechaRevisadoFinanzas: null,
        IdUsuarioVentas: null,
        FechaRevisadoVentas: null,
        FechaFormatoCompletado: null,
        ComentarioRevisadoVentas: null,
        ComentarioRevisadoFinanzas: null
    });

    const { userAuth } = useContext(AuthContext);

    const obtenerInformacion = async () => {

        const result = await getInfoCliente(IdCliente, Token);
        if (result?.length > 0) {

            const tempoEstadosRevision = await getEstadosCategoryIPS("Revision Cliente");

            let estadosFiltrados = tempoEstadosRevision
            if (userAuth?.IdRol !== 1) {
                if ([6].includes(userAuth?.IdRol)) {
                    estadosFiltrados = tempoEstadosRevision?.filter((s) => s.IdStatus === 3736);
                }
                if ([17].includes(userAuth?.IdRol)) {
                    estadosFiltrados = tempoEstadosRevision?.filter((s) => s.IdStatus === 3737);
                }
            }


            setValues(result[0])

            setEstadosRevision(estadosFiltrados);
        }
    }

    const CambiarEstado = async () => {
        if (!values.IdEstadoRevisado) {
            toastShow(toast, "warn", "Requerido", "Debe seleccionar el estado");
            return;
        } else {

            let datosEnviar = {
                IdCustomer: values.IdCustomer,
                IdRegistro: values.IdRegistro,
                IdEstadoRevisado: values.IdEstadoRevisado,
                IdUsuarioFinanzas: values.IdEstadoRevisado === 3737 ? userAuth?.idUser : values?.IdUsuarioFinanzas,
                ComentarioRevisadoFinanzas: values?.ComentarioRevisadoFinanzas,
                FechaRevisadoFinanzas: values.IdEstadoRevisado === 3737 ? getDateTimeStringSQL24(new Date()) : values?.FechaRevisadoFinanzas,

                IdUsuarioVentas: values.IdEstadoRevisado === 3736 ? userAuth?.idUser : values?.IdUsuarioVentas,
                ComentarioRevisadoVentas: values.ComentarioRevisadoVentas,
                FechaRevisadoVentas: values.IdEstadoRevisado === 3736 ? getDateTimeStringSQL24(new Date()) : values?.FechaRevisadoVentas,
                Token: Token
            }
            const result = await CambiarEstadoInscripcion(datosEnviar, Token)
            if (result?.length > 0) {
                if (result[0]?.ESTADO === 1) {
                    toastShow(toast, 'success', 'Estado Actualizado Correctamente')
                    setTimeout(() => {
                        hideDialog()
                    }, 600);
                } else {
                    toastShow(toast, 'error', result[0]?.MENSAJE)
                }
            }
        }
    }

    const DialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            {userAuth?.idUser > 0 &&
                <Button label="Aceptar" icon="pi pi-check" className="p-button-text" onClick={() => CambiarEstado()} loading={loading} />}
        </React.Fragment>
    );
    useEffect(() => {
        if (visible) {
            obtenerInformacion()
        } else {
            resetForm({})
        }
    }, [visible])
    return (
        <Dialog visible={visible} onHide={hideDialog} style={{ width: '60vw', height: '45vh' }} header={<h4>{values?.CustomerName}</h4>}
            footer={DialogFooter}>
            <Toast ref={toast} />
            <div className="px-4">
                <p>
                    Al cambiar el estado de revisión del cliente, usted confirma que ha
                    revisado y validado toda la información correspondiente.
                </p>

                {estadosRevision?.map((estado) => (
                    <div key={estado.Id} className="field-checkbox gap-2">
                        <Checkbox
                            inputId={`estado_${estado?.IdStatus}`}
                            checked={estado?.IdStatus === values.IdEstadoRevisado}
                            onChange={(e) => {
                                handleChange((e.checked ? estado?.IdStatus : null), 'IdEstadoRevisado')
                            }}
                        />
                        <label htmlFor={`estado_${estado.IdStatus}`} className="ml-2" style={{ fontWeight: 600 }}>
                            {estado.StatusName}
                        </label>
                    </div>
                ))}
                <div className="pt-2" style={{ width: '100%' }}>
                    {[1, 6].includes(userAuth?.IdRol) ?
                        <span className="p-float-label " >
                            <InputText
                                value={values.ComentarioRevisadoVentas}
                                onChange={(e) => handleInputChange(e, 'ComentarioRevisadoVentas')}
                                style={{ width: '100%' }}
                                disabled={values.IdEstadoRevisado !== 3736}
                            />
                            <label>Comentario Revisado Ventas</label>
                        </span>
                        : null
                    }
                    {[1, 17].includes(userAuth?.IdRol) ?
                        <span className="p-float-label pt-4 " style={{ width: '100%' }}>
                            <InputText
                                value={values.ComentarioRevisadoFinanzas}
                                onChange={(e) => handleInputChange(e, 'ComentarioRevisadoFinanzas')}
                                style={{ width: '100%' }}
                                disabled={values.IdEstadoRevisado !== 3737}
                            />
                            <label>Comentario Revisado Finanzas</label>
                        </span>
                        : null
                    }
                </div>

            </div>
        </Dialog>
    )
}

export default DialogEstadoRevisadoClientes
